export class CommandCounsellorsService {
  constructor($resource, ApiService) {
    "ngInject";

    this.$resource = $resource;
    this.apiService = ApiService;
    this.commandCounsellorsUrl = this.apiService.getResourceUrl(
      "/account/command-career-counsellors"
    );
    this.commandCounsellorResource = this.$resource(
      this.commandCounsellorsUrl,
      null,
      { query: { method: "get", cancellable: true } }
    );
    this.commandCounsellorsQuery = null;
  }

  getCommandCounsellorsList(params = {}) {
    if (this.commandCounsellorsQuery) {
      this.commandCounsellorsQuery.$cancelRequest();
    }
    this.commandCounsellorsQuery = this.commandCounsellorResource.query(params);
    return this.commandCounsellorsQuery.$promise.then(({ details }) => details);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/command-counsellors/command-counsellors.service.js